// simple pub sub module from nodejs
const EventEmitter = require('events')

class Events extends EventEmitter {
  off (event, callback) {
    this.removeListener(event, callback)
  }
}

const events = new Events()

events.setMaxListeners(2000)

export default events
